import { useEffect } from 'react'

/**
 * Releases an object URL once nothing shows it any more: when `url` is replaced
 * by another one, and when the component unmounts. Without this every opened
 * preview keeps its whole file in memory until the tab closes.
 *
 * Only `blob:` URLs are revoked, so a caller may pass a plain endpoint URL too.
 * Callers hold the URL in state that starts empty, so StrictMode's mount-time
 * double effect never sees a live URL and no delay is needed.
 */
export function useRevokeObjectUrl(url: string | null | undefined): void {
  useEffect(() => {
    if (!url?.startsWith('blob:')) return
    return () => URL.revokeObjectURL(url)
  }, [url])
}
